import styles from '../../ListPage.module.scss'
import Button from 'components/commons/Button/Button'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'

const NoCaseMessage: React.FC = () => {
  const nocaseRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const nocaseElements = nocaseRef.current?.querySelectorAll('div, p, a') || []

    gsap.set(nocaseElements, { opacity: 0, y: 50 })

    if (nocaseRef.current) {
      gsap.to(nocaseElements, {
        opacity: 1,
        y: 0,
        duration: 1,
        stagger: 0.2,
        ease: Power4.easeOut,
      })
    }
  }, [])

  return (
    <div className={styles.nocase} ref={nocaseRef}>
      <div className={styles.nocase_inner}>
        <div className={styles.nocase_inner_head}>
          <p className={styles.nocase_inner_head_main}>Coming soon</p>
          <p className={styles.nocase_inner_head_sub}>事例紹介準備中</p>
        </div>
        <div className={styles.nocase_inner_bottom}>
          <p className={styles.nocase_inner_bottom_text}>
            サービス詳細を別途ご案内可能です
            <br />
            お気軽にお問い合わせください
          </p>
          <Button text="お問い合わせ" href="/contact/" red="red" />
        </div>
      </div>
    </div>
  )
}

export default NoCaseMessage
